/**
 * RUTEX Backoffice - API Endpoints Dictionary
 */
export const Endpoints = {
  // Authentication & Session
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  ME: '/auth/me',
  UPDATE_INITIAL_PASSWORD: '/auth/actualizar-clave-inicial',

  // User & Employee Catalogs
  USER_CATALOGS: '/admin/catalogs/employee-options',

  // Users & Employee Management
  USERS: '/admin/users',
  EMPLOYEES: '/admin/employees',
  USER_BY_ID: (id) => `/admin/users/${id}`,
  TOGGLE_USER_STATUS: (id) => `/admin/users/${id}/toggle-status`,
  SELLERS: '/admin/sellers',
  MERCHANDISERS: '/admin/merchandisers',
  ZONE_IMPACT: '/admin/users/zone-impact',

  // Zones
  ZONES: '/admin/zones',
  ZONE_BY_ID: (id) => `/admin/zones/${id}`,

  // Customers (Clientes)
  CUSTOMERS: '/admin/customers',
  CUSTOMER_BY_ID: (id) => `/admin/customers/${id}`,
  CUSTOMER_IMPORT: '/admin/customers/import',
  CUSTOMER_IMPORT_TEMPLATE: '/admin/customers/import-template',
  CUSTOMER_APPROVE: (id) => `/admin/customers/${id}/approve`,
  TOGGLE_CUSTOMER_STATUS: (id) => `/admin/customers/${id}/toggle-status`,

  // FAQs, Help Center & Support Tickets
  FAQS: '/admin/faqs',
  FAQ_BY_ID: (id) => `/admin/faqs/${id}`,
  TOGGLE_FAQ_STATUS: (id) => `/admin/faqs/${id}/toggle`,
  MOBILE_FAQS: '/mobile/faqs',
  SUPPORT_TICKETS: '/admin/support-tickets',
  SUPPORT_TICKET_BY_ID: (id) => `/admin/support-tickets/${id}`,
  CORE_SETTINGS: '/core/settings',

  // Merchandising & Trade Marketing
  MERCHANDISING_REPORTS: '/audit/merchandising/reports',
  MERCHANDISING_ANALYTICS: '/audit/merchandising/analytics',
  MERCHANDISING_REPORT_BY_ID: (id) => `/audit/merchandising/reports/${id}`,
  MERCHANDISING_REPORT_BY_VISIT: (visitId) => `/audit/merchandising/reports/visit/${visitId}`,
  MERCHANDISING_REPORT_BY_CUSTOMER: (customerId) => `/audit/merchandising/reports/customer/${customerId}/latest`,

  SELLER_ANALYTICS_DASHBOARD: '/sales/analytics/dashboard',
  SELLER_COMMISSION_TIERS: '/sales/analytics/commission-tiers',
  SELLER_TARGETS: '/sales/analytics/targets',
  SELLER_MOBILE_PERFORMANCE: '/sales/analytics/seller-performance',
};

export default Endpoints;
